// extracted by mini-css-extract-plugin
export default {"heading":"vt-z","corrected":"wt-z","redirectVerbiageContainer":"xt-z","redirectVerbiageText":"yt-z"};